var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showing)?_c('img',{staticClass:"h-20 inline-flex rounded border bg-white p-1 dark:border-neutral-700 dark:bg-neutral-800",attrs:{"src":_vm.image,"alt":"..."},on:{"error":function($event){_vm.showing = false}}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }